<template>
    <div class="chart-line-container">
        <canvas ref="canvas"></canvas>
    </div>
</template>

<style>
    .chart-line-container {
        position: relative;
        height: 99%;
        width: 99%;
    }
</style>

<script>
    import Chart from 'chart.js';

    export default {
        props: ['allData'],
        data() {
            return {
                chart: null,
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                    },
                    scales: {
                        xAxes: [{
                        gridLines: {
                            display: false
                        }
                        }],
                        yAxes: [{
                        gridLines: {
                            display: false
                        },
                        ticks: {
                            count: 6,
                            autoSkip: false
                        }
                        }]
                    }
                }
            }
        },
        created() {
            this.title = 'Comprobantes';
        },
        mounted() {
            this.$nextTick(() => {
                this.createChartIfReady()
                // segundo tick para casos de collapse/animación
                setTimeout(() => this.resizeChart(), 50)
            })

            // opcional: escuchar un evento global para refrescar al abrir el panel
            this._onResize = () => this.resizeChart()
            if (this.$eventHub) this.$eventHub.$on('dashboard:resize-charts', this._onResize)
        },
        watch: {
            // allData() {
            //     this.createChart();
            // }
            allData: {
                handler() {
                    this.$nextTick(() => {
                    this.createChartIfReady()
                    this.resizeChart()
                    })
                },
                deep: true
            }
        },
        methods: {
            createChartIfReady() {
                if (!this.allData || !this.allData.labels || !this.allData.datasets) return
                this.createChart()
            },
            createChart() {
                if (this.chart) {
                    this.chart.destroy();
                }
                this.chart = new Chart(this.$refs.canvas.getContext('2d'), {
                    type: 'line',
                    data: {
                        labels: this.allData.labels,
                        datasets: this.allData.datasets,
                    },
                    options: this.options,
                });
            },
            resizeChart() {
                if (this.chart) {
                    // Chart.js recalcula tamaños
                    this.chart.resize()
                    this.chart.update(0)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/graph/src/GraphLine.vue